import React from 'react'
import Tooltip from 'rc-tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'

import 'assets/css/rc-tooltip.css'

import Button from 'components/elements/Button'

const Footnote = ({ value }) => {
   const alignConfig = {
      points: ['bl', 'tl'], // align top left point of sourceNode with top right point of targetNode
      offset: [0, 0], // the offset sourceNode by 10px in x and 20px in y,
      targetOffset: [25, 5],
   }
   return (
      <Tooltip animation="zoom" trigger="click" overlay={value} align={alignConfig} destroyTooltipOnHide>
         <Button>
            <FontAwesomeIcon icon={faEllipsisH} />
         </Button>
      </Tooltip>
   )
}
export default Footnote
